import { PickerView, Popup, VirtualInput } from "antd-mobile";
import { useEffect, useState } from "react";
import "./index.less";
import React from "react";
import { isValid } from "@formily/shared";
import { Field, isVoidField } from "@formily/core";
import {
  connect,
  useField,
  mapProps,
  mapReadPretty,
  observer,
} from "@formily/react";
interface Item {
  label: string;
  value: string;
  [propName: string]: any;
}

interface IProps {
  value?: string;
  max?: number;
  onChange?: (items: Item) => void;
  placeholder?: string;
  // options?: Item[];
}
const Cmp = (props) => {
  console.log("Cmp走到只读状态", props);
  return <div>{props.value}</div>;
};
export const EnumSelect = observer((props: IProps) => {
  const field: any = useField<Field>();
  // console.log(field, "f==================ield的值----------");
  const dataSource = field?.dataSource?.length ? field?.dataSource : [];
  // console.log(
  //   dataSource,
  //   "CustomAntdSelect========dataSourceOrg的值----------"
  // );
  const { onChange, placeholder, value } = props;
  const [visible, setVisible] = useState(false);
  const [selectedValue, setSelectedValue] = useState<any>();
  const [showValue, setShowValue] = useState<any>();
  let initValueItem = dataSource?.filter((item) => item.value === value);
  let labelValue = null;
  if (initValueItem.length > 0) {
    labelValue = initValueItem[0]?.label;
  }
  // 点击单选框的处理函数
  const handleRadioChange = (item: Item) => {
    onChange(item);
  };
  if (!isVoidField(field) && field?.pattern === "readPretty") {
    return <Cmp />;
  }

  return (
    <div>
      {/* <div
        className="searchSelectorEntry"
        onClick={() => {
          setVisible(true);
        }}
        key="searchSelectorEntry"
      >
        {showValue?.label || field?.initialValue ? (
          <span className={"plzSelectValue"}>{showValue?.label}</span>
        ) : (
          <span className={"plzSelect"}>{placeholder || "请选择"}</span>
        )}
      </div> */}

      <VirtualInput
        placeholder={placeholder || "请选择"}
        value={showValue?.label || labelValue}
        onClick={() => {
          setVisible(true);
        }}
      />
      <Popup
        key="selectPopup"
        visible={visible}
        onMaskClick={() => {
          setVisible(false);
        }}
        getContainer={() => null}
        bodyStyle={{ height: "345px" }}
      >
        <div className={"enumSelect"} key="enumSelect">
          <div key="title" className={"title"}>
            选择{field?.title}
          </div>
          <PickerView
            defaultValue={[value]}
            columns={[dataSource]}
            onChange={(_, extend: any) => {
              setSelectedValue(extend.items[0]);
            }}
            style={{
              "--height": "235px",
            }}
            key="EnumSelect"
          />
          <div className={"buttonStyle"} key="buttonStyle">
            <div
              className={"buttonText"}
              key="buttonText"
              onClick={() => {
                setVisible(false);
                setShowValue(selectedValue);
                handleRadioChange(selectedValue.value);
              }}
            >
              确认
            </div>
          </div>
        </div>
      </Popup>
    </div>
  );
});

export default EnumSelect;
